import React, { useState } from 'react'
import styled from 'styled-components'
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem
} from 'reactstrap'

const QuestionIcon = styled.i`
  color: var(--bs-primary);
  margin-right: 0.5rem;
  flex-shrink: 0;
  font-size: 0.85em;
  transition: transform 0.2s ease;
`

const FaqsWrapper = styled.section`
  .accordion {
    --bs-accordion-body-padding-x: 1rem;
    --bs-accordion-body-padding-y: 0.75rem;
  }

  .accordion-button {
    transition:
      background-color 0.2s ease,
      color 0.2s ease,
      padding-left 0.2s ease;
  }

  .accordion-button.collapsed:hover {
    color: var(--bs-primary);
    background-color: rgba(var(--bs-primary-rgb), 0.08);
    padding-left: 1.5rem;
  }

  .accordion-button.collapsed:hover ${QuestionIcon} {
    transform: translateX(0.2rem);
  }
`

const FaqHeader = styled(AccordionHeader).attrs({
  tag: 'h3'
})`
  margin: 0;
  padding: 0;
  font-size: inherit;
  line-height: inherit;
`

const FaqBody = styled(AccordionBody)`
  p:last-child {
    margin-bottom: 0;
  }
`

const Faqs = ({ faqs }) => {
  const [open, setOpen] = useState('')

  let faqsArray = []

  try {
    faqsArray = typeof faqs === 'string'
      ? JSON.parse(faqs)
      : faqs
  } catch (error) {
    console.error('Invalid FAQs JSON:', error)
    return null
  }

  if (!Array.isArray(faqsArray)) {
    return null
  }

  const validFaqs = faqsArray.filter(
    (faq) => faq?.question || faq?.answer
  )

  if (validFaqs.length === 0) {
    return null
  }

  const toggle = (id) => {
    setOpen((currentOpen) => (
      currentOpen === id ? '' : id
    ))
  }

  return (
    <FaqsWrapper className="faqs">
      <Accordion open={open} toggle={toggle}>
        {validFaqs.map((faq, index) => {
          const id = String(index)

          return (
            <AccordionItem key={id}>
              <FaqHeader targetId={id}>
                <QuestionIcon
                  className="fa fa-chevron-right"
                  aria-hidden="true"
                />

                <span>
                  {faq.question || `Pregunta ${index + 1}`}
                </span>
              </FaqHeader>

              <FaqBody accordionId={id}>
                {faq.answer}
              </FaqBody>
            </AccordionItem>
          )
        })}
      </Accordion>
    </FaqsWrapper>
  )
}

export default Faqs